<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />
    <v-card min-height="40vh">
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-caption">
          Staff can <b> never </b> administer meds to {{ userCompany }} Clients without following the proper
          two-person Medication Administration Protocol, which includes knowing your responsibilities
          as both Med Administrator and a Med Checker.
        <br />
        <ul>
            <li> <b> Med Administrator Duties: </b> Responsible for documenting and administering the meds and
            documenting those meds on the MAR (must have a current Medication Administration Certification). </li>
            <li> <b> Med Checker Duties: </b> Responsible for verifying each med to ensure it is on the MAR, and verifying
            the pill count PRIOR to the Med Administer actually giving the meds.</li>
            <li> <b> BOTH </b> MED ADMINISTRATOR AND MED CHECKER WILL <b> INITIAL, THE BACK OF THE MED CARDS, </b> AND THE
            MED ADMINISTRATOR <b> WILL ADD THE NAME </b> OF THE MED CHECKER <b> TO THE NOTES IN THE MAR. </b> </li>
        </ul>
        </p>
        <p class="text-caption">
         All Staff <b> MUST </b> follow:
        <b> SIX RIGHTS OF MEDICATION ADMINISTRATION </b>
        </p>
        <p class="text-caption">
            As Medication Administer (MAs), you are required to follow the Six Rights of Medication Administration:
        </p>
        <p class="text-caption">
           <ul>
                <li> <b> #1- Right patient: </b> Make sure that the medication sheet has the name of the client and that the
                bubble pack has the name of the client. Check two identifiers, such as picture on the medication sheet
                that matches the client or the client stating their name, prior to administration.</li>
                <li> <b> #2- Right Medication: </b> Check to verify that the medication in the bubble pack is the same
                medication listed on the MAR</li>
                <li> <b> #3-Right Dose: </b> Also check that the doses are correct.</li>
                <li> <b> #4- Right Time: </b> Look at the MAR alongside the bubble pack and make sure it is the right
                time of administration</li>
                <li> <b> #5- Right Route: </b> Watch the client take the medication per the right route.</li>
                <li> <b> #6- Right Documentation: </b> After client has taken medication, follow propeer medication documentation.</li>
          </ul>
        </p>
         <p class="text-caption">
         <b> By signing below, I
         <b>
              <span class="text-decoration-underline text-uppercase">{{
                user.Name
              }}</span>
        </b>
        acknowledge and will follow the Medication Administration Protocol by following the two-person
         med administration procedure. If I do not follow the above protocol either as the Med
         Administrator or the Med Checker, consequences wil include:
        </b>
        <ul>
            <li> <b> 1st offense </b> - Adjustment plus Removed from shift unpaid</li>
            <li> <b> 2nd offense </b> -Adjustment plus Removed from the schedule for 5 days unpaid</li>
            <li> <b> 3rd offense </b> - Immediate Removal of Medicarion Administration Rights.</li>
        </ul>
        </p>


      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Employee's Signature"
                @click.stop="showSignaturePad = true"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="employeeSignatureInMedication"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */
import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { SignaturePad },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      dateMenu: false,
      employeeSignature: "",
      showSignaturePad: false,
      item: {},
      step: this.currentStep,
    };
  },

  created() {
    this.populateUserInfo();
    const savedSignature = localStorage.getItem("employeeSignatureInMedication");
    if (savedSignature) {
      this.signatureData(savedSignature);
    }
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
    ...mapGetters("users", {
      user: "user",
      userCompany: "userCompany",
    }),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),
    signatureData(data) {
      this.employeeSignatureInMedication = data;
      localStorage.setItem("employeeSignatureInMedication", data);
    },

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },
    prev() {
      this.$emit("clicked", this.step - 1);
    },

    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "client-transportation-agreement",
        });
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {
      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.ClientTransportationAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
          signedDate: moment(documents.signedDate).format("YYYY-MM-DD"),
          dateSigned: moment(documents.dateSigned).format("YYYY-MM-DD"),
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "client-transportation-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(
        pdfFile,
        "client-transportation-agreement.pdf",
        "application/pdf"
      );
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
